import { requestJson, withQuery } from "./http/httpClient";
import { readArray, readNullableString, readObject, readString, type JsonObject } from "./http/jsonDecoding";

/**
 * A group as invitations and the installation's settings name it. The groups themselves,
 * their permissions, order and members, are in `access/` (accounts.md GS-1 to GS-6).
 */
export interface Group {
  readonly groupId: string;
  readonly name: string;
  /** The project a project group belongs to; `null` for an installation group. */
  readonly projectId: string | null;
  /** The installation group it sits in. */
  readonly parentId: string | null;
}

/** The groups the user may carry in an invitation (GS-7), as the server's rule says: the
 * installation's for whoever manages accounts, and with a project its own groups, each only
 * where the user may manage it; never Everyone or Administrators. */
export function listInvitationGroups(projectId: string | null, signal?: AbortSignal): Promise<readonly Group[]> {
  return requestJson({
    method: "GET",
    path: withQuery("/accounts/invitations/groups", { project_id: projectId }),
    signal,
    decodeResponse: (body) => readArray(body, "invitation groups", (item) => decodeGroup(readObject(item, "group"))),
  });
}

function decodeGroup(group: JsonObject): Group {
  return {
    groupId: readString(group, "group_id"),
    name: readString(group, "name"),
    projectId: readNullableString(group, "project_id"),
    parentId: readNullableString(group, "parent_id"),
  };
}
